export default __webpack_public_path__ + "static/4-8cbe898b20e80145d3d0841ad2a7ca3c.jpg";